import { useState } from "react";
import { toast } from "../hooks/use-toast";
import api from "../services/api";
import { useNavigate } from "react-router-dom";

const AdminVerifyCode = () => {
  const navigate = useNavigate();

  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/password/verify-code", { code });
      const userId = res.data.userId;
     
      toast({
        title: "Code Verified",
        description: "You can now reset your password",
      });
      navigate(`/admin/reset-password/${userId}`);
    } catch (err) {
      toast({
        title: "Error",
        description: err.response?.data?.message || "Invalid code",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-custom py-20">
      <div className="max-w-md mx-auto bg-card p-8 rounded-2xl shadow-soft">
        <h2 className="text-xl font-semibold mb-4">Enter Verification Code</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            placeholder="Enter code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
            className="w-full px-4 py-3 rounded-xl border border-border focus:border-primary outline-none"
          />
          <button type="submit" className="btn-hero w-full" disabled={loading}>
            {loading ? "Verifying..." : "Verify Code"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminVerifyCode;
